<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleContract.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleContract.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>

          <div class="d-flex ts-space-x-3 ts-items-center">
            <!-- <a-radio-group
              v-model="has_create_si"
              option-type="button"
              :options="plainOptions"
              @change="fetchData()"
            /> -->
            <div class="ts-flex ts-space-x-1">
              <label class="ts-py-2 ts-mb-0">{{
                $t('saleContract.SIStatusFilter')
              }}</label>
              <a-radio-group v-model="has_create_si" @change="fetchData()">
                <a-radio-button>All</a-radio-button>
                <a-radio-button value="1">Yes</a-radio-button>
                <a-radio-button value="0">No</a-radio-button>
                <a-radio-button value="2">Cancel</a-radio-button>
              </a-radio-group>
            </div>
            <a-select
              v-model="scStatusId"
              mode="multiple"
              :maxTagTextLength="17"
              :maxTagCount="1"
              :options="statusList"
              class="ts-w-64"
            ></a-select>
            <ts-input
              v-tooltip="$t('saleContract.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'contract_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.project_name }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.contract_no }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              <span
                class="badge"
                :class="
                  record.is_deleted
                    ? 'bg-warning'
                    : record.sale_invoice_count
                    ? 'bg-info'
                    : 'bg-danger'
                "
                >{{
                  record.is_deleted
                    ? 'Cancel'
                    : record.sale_invoice_count
                    ? 'Yes'
                    : 'No'
                }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{
                record.is_deleted
                  ? record.modified_date
                  : record.sale_invoice
                  ? record.sale_invoice.stock_out_date
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.sale_invoice ? record.sale_invoice.invoice_no : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer.customer_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.project_name }}</td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{
                record.total_exclude_vat == 0
                  ? 0
                  : $defaultCurrencyWithCode(record.total_exclude_vat)
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{
                record.grand_total == 0
                  ? 0
                  : $defaultCurrencyWithCode(record.grand_total)
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <span
                class="badge"
                :class="
                  record.sc_status_id == 1
                    ? 'bg-danger'
                    : record.sc_status_id == 2
                    ? 'bg-info'
                    : record.sc_status_id == 3
                    ? 'bg-success'
                    : ''
                "
                >{{ record.sc_status }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.created_by.name }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-left">
              {{ record.is_deleted ? record.deleted_reason : '' }}
            </td>
            <td class="text-left ts-space-x-3 ts-whitespace-no-wrap">
              <a
                href="#"
                v-tooltip="$t('deliveryOrder.reprint')"
                class="text-primary text-red"
                @click.prevent="previewPdf(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                v-if="!record.is_deleted"
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                v-if="!record.is_deleted"
                placement="leftTop"
                v-tooltip="$t('cancel')"
                :title="$t('saleContract.are_you_sure_to_cancel')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-ban text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'

export default {
  name: 'saleContract',
  components: {
    Reason
  },
  data() {
    return {
      plainOptions: [
        { label: 'All', value: undefined },
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
      ],
      loading: false,
      waiting: false,
      src: null,
      show_pdf: false,
      model: {
        deleted_reason: null
      },
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('wholesale/saleContract', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.saleContract.search
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_SEARCH', newValue)
        this.$store.commit('wholesale/saleContract/RESET_CURRENT_PAGE')
      }
    },
    scStatusId: {
      get() {
        return this.$store.state.wholesale.saleContract.sc_status_id
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_STATUS_FILTER', newValue)
      }
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.saleContract.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_DATE_RANGE', newValue)
      }
    },
    has_create_si: {
      get() {
        return this.$store.state.wholesale.saleContract.has_create_si
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_HAS_CREATE_SI', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('saleContract.branchName') },
        { name: this.$t('saleContract.project') },
        { name: this.$t('saleContract.contractNo') },
        {
          name: this.$t('saleContract.SIStatus'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleContract.SIdate'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleContract.invoiceNo'),
          style: 'text-align:center'
        },
        { name: this.$t('saleContract.customer') },
        { name: this.$t('saleContract.projectName') },
        {
          name: this.$t('saleContract.totalExcludevat'),
          style: 'text-align:right'
        },
        {
          name: this.$t('saleContract.grandTotal'),
          style: 'text-align:right'
        },
        { name: this.$t('saleContract.status') },
        {
          name: this.$t('saleContract.createdBy'),
          style: 'text-align:right'
        },
        {
          name: this.$t('saleContract.cancelReason')
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    },
    statusList() {
      return this.$store.state.wholesale.saleContract.status.map(el => ({
        value: el.sc_status_id,
        label: el.sc_status
      }))
    }
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'sale-contract-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/saleContract/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('wholesale/saleContract/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'sale-contract-edit',
        params: { id: record.contract_id }
      })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('saleContract.are_you_sure_to_cancel'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('saleContract.cancelReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('wholesale/saleContract/destroy', {
              id: record.contract_id,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/saleContract/SET_BRANCH_ID', value)
      this.fetchData()
    },
    previewPdf(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('wholesale/saleContract/previewPdf', record.contract_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchStatus() {
      this.$store.dispatch('wholesale/saleContract/getStatus').catch(error => {
        this.$toasted.error(error.message)
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500),
    scStatusId: debounce(function(id) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/saleContract/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.fetchStatus()
    })
  }
}
</script>

<style scoped></style>
